import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';

export const ConfirmChanges: FC<{
  isLoading: boolean;
  handleCancel: () => void;
}> = ({ isLoading, handleCancel }) => {
  return (
    <Form.Item shouldUpdate>
      <Button
        type="primary"
        htmlType="submit"
        loading={isLoading}
        disabled={isLoading}
        data-cy="project.settings.general_info.save"
      >
        <FormattedMessage id="save" />
      </Button>
      <Button
        disabled={isLoading}
        style={{ marginLeft: 'var(--spacing-05)' }}
        onClick={handleCancel}
        htmlType="reset"
        data-cy="project.settings.general_info.cancel"
      >
        <FormattedMessage id="cancel" />
      </Button>
    </Form.Item>
  );
};
